import { useSingleImageEffect } from '@/src/components/Upload';
import { last } from 'lodash';
import React from 'react';
import { Uploader } from 'src/components/Upload';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const SingleImageUploader = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onChange, value: linkImage, id, height, type, disabled } = props;
  const [fileList, setFileList] = React.useState(linkImage ? [linkImage] : []);
  useSingleImageEffect(linkImage, fileList, setFileList);
  return (
    <div id={id} style={{ width: 180 }}>
      <Uploader
        btnText={getI18n('general.selectFiles')}
        height={height}
        multiple={false}
        fileList={fileList}
        type={type}
        disabled={disabled}
        onChange={(imgArr = []) => {
          setFileList(imgArr);
          if (onChange) {
            const _l = last(imgArr);
            onChange(_l);
          }
        }}
      />
    </div>
  );
};
export default SingleImageUploader;
